import { c as _c } from "react/compiler-runtime";
import { useToast } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
/**
 * Returns the callback for when a group ceases to exist, either because its last member was
 * unassigned or because it was deleted outright. The page it was showing is gone, so it goes
 * back to the groups list and names the group that was removed.
 *
 * The group is not dropped from the store here: that would make this page render without it and
 * refetch its content for a group ID the backend has already dropped. The groups list prunes it
 * instead, once it has fetched the groups that are left.
 */
export function useOnGroupRemoved(t0) {
  const $ = _c(5);
  const {
    companyId,
    groupName
  } = t0;
  const {
    navigateToGroups
  } = useAppNavigation();
  const {
    openToast
  } = useToast();
  let t1;
  if ($[0] !== companyId || $[1] !== groupName || $[2] !== navigateToGroups || $[3] !== openToast) {
    t1 = function onGroupRemoved() {
      navigateToGroups({
        companyId
      });
      openToast({
        title: <>Successfully removed group <var>{groupName}</var></>
      });
    };
    $[0] = companyId;
    $[1] = groupName;
    $[2] = navigateToGroups;
    $[3] = openToast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}